import { render } from "./AccountDetail.vue?vue&type=template&id=31784cbb&scoped=true"
import script from "./AccountDetail.vue?vue&type=script&lang=js"
export * from "./AccountDetail.vue?vue&type=script&lang=js"

import "./AccountDetail.vue?vue&type=style&index=0&id=31784cbb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31784cbb"]])

export default __exports__